import { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import HelpTooltip from '../../../../components/tooltip/HelpTooltip'
import CurrencyInput from '../../../../components/form/CurrencyInput'
import CheckBox from '../../../../components/form/CheckBox'
import AmountWarn from '../../AmountWarn'
import { integerValue } from '../../../../utils'
import { setDailyBudgetAmount, setDailyBudgetYn } from '../campaignSlice'

const CampaignDailyBudget = ({ error }) => {
  const dispatch = useDispatch()
  const {
    dailyBudgetYn,
    dailyBudgetAmount,
    beforeDailyBudgetYn,
    beforeDailyBudgetAmount,
  } = useSelector(state => state.ad.campaign.form)
  const handleValueChange = useCallback(
    value => {
      dispatch(setDailyBudgetAmount(integerValue(value)))
    },
    [dispatch]
  )
  const handleCheckedChange = useCallback(
    checked => dispatch(setDailyBudgetYn(checked ? 'N' : 'Y')),
    [dispatch]
  )
  return (
    <div className={classNames('area_item', { error })}>
      <strong className="subtit_box">
        일예산
        <HelpTooltip>
          하루 기준의 통합 지출 한도를 의미하며,
          <br />일 예산을 초과할 경우 광고 집행이 중지됩니다.
        </HelpTooltip>
      </strong>
      <div className="cont_card">
        <div className="item_card">
          <div className="group_item">
            <CurrencyInput
              name="dailyBudgetAmount"
              disabled={dailyBudgetYn === 'N'}
              min={1000}
              max={10000000}
              step={10}
              maxLength={8}
              value={dailyBudgetAmount}
              error={error}
              onValueChange={handleValueChange}
            />
            <CheckBox
              label="미설정"
              name="dailyBudgetYn"
              checked={dailyBudgetYn === 'N'}
              onCheckedChange={handleCheckedChange}
            />
            <AmountWarn
              before={
                beforeDailyBudgetYn === 'N'
                  ? undefined
                  : beforeDailyBudgetAmount
              }
              after={dailyBudgetYn === 'N' ? undefined : dailyBudgetAmount}
              error={error}
            />
          </div>
          <p className={error ? 'txt_error' : 'desc_item'}>
            캠페인 일예산은 최소 1,000원 ~ 최대 1천만원까지 10원 단위로 설정할
            수 있습니다.
          </p>
        </div>
      </div>
    </div>
  )
}
CampaignDailyBudget.propTypes = {
  error: PropTypes.string,
}
export default CampaignDailyBudget
